import { render, staticRenderFns } from "./ambitosFormulario.vue?vue&type=template&id=34187518&"
import script from "./ambitosFormulario.vue?vue&type=script&lang=ts&"
export * from "./ambitosFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports